import React, { useState, useRef, useEffect } from "react";

const API_URL = "https://eveliobustosapache.com/backend";

const TestimonialForm = ({ onNewTestimonial }) => {
  const [formData, setFormData] = useState({
    nombre: "",
    mensaje: "",
    avatar: null,
  });
  const [fileName, setFileName] = useState("");
  const [status, setStatus] = useState("");
  const [sending, setSending] = useState(false);
  const fileInputRef = useRef(null);
  const clearTimerRef = useRef(null);

  // Limpia el temporizador al desmontar
  useEffect(() => {
    return () => {
      if (clearTimerRef.current) clearTimeout(clearTimerRef.current);
    };
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "avatar") {
      const file = files?.[0] ?? null;
      setFormData((prev) => ({ ...prev, avatar: file }));
      setFileName(file ? file.name : "");
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus("Enviando...");

    const data = new FormData();
    data.append("nombre", formData.nombre);
    data.append("mensaje", formData.mensaje);
    if (formData.avatar) data.append("avatar", formData.avatar);

    try {
      const res = await fetch(`${API_URL}/api/agregar_testimonio.php`, {
        method: "POST",
        body: data,
      });

      const text = await res.text();
      let result;
      try {
        result = JSON.parse(text);
      } catch {
        throw new Error(text);
      }

      if (result.success) {
        onNewTestimonial(result.data);
        setFormData({ nombre: "", mensaje: "", avatar: null });
        setFileName("");
        if (fileInputRef.current) fileInputRef.current.value = "";
        setStatus("¡Gracias por tu testimonio!");
        if (clearTimerRef.current) clearTimeout(clearTimerRef.current);
        clearTimerRef.current = setTimeout(() => setStatus(""), 3000);
      } else {
        setStatus("Error: " + (result.message || "No se pudo guardar."));
      }
    } catch (err) {
      setStatus("Error al enviar: " + String(err.message || err));
    } finally {
      setSending(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-[#211F1F] rounded-2xl shadow-lg p-6 space-y-4"
      encType="multipart/form-data"
    >
      <h3 className="text-2xl font-semibold text-center mb-4" style={{ color: '#E8B00C' }}>
        Deja tu testimonio
      </h3>

      <input
        type="text"
        name="nombre"
        value={formData.nombre}
        onChange={handleChange}
        placeholder="Tu nombre"
        required
        className="w-full px-4 py-2 rounded-lg bg-gray-800 text-white border border-gray-700 focus:ring-2 focus:ring-[#E8B00C]"
      />

      <textarea
        name="mensaje"
        value={formData.mensaje}
        onChange={handleChange}
        placeholder="Escribe tu experiencia..."
        rows="4"
        required
        className="w-full px-4 py-2 rounded-lg bg-gray-800 text-white border border-gray-700 focus:ring-2 focus:ring-[#E8B00C]"
      />

      {/* Input file personalizado */}
      <div>
        <input
          ref={fileInputRef}
          type="file"
          name="avatar"
          accept="image/*"
          onChange={handleChange}
          className="hidden"
          id="avatar-upload"
        />
        <label
          htmlFor="avatar-upload"
          className="flex items-center justify-center gap-2 w-full px-4 py-2 rounded-lg bg-gray-800 border border-gray-700 cursor-pointer hover:bg-gray-700 transition-colors text-gray-300"
        >
          <svg
            className="w-5 h-5"
            style={{ color: '#E8B00C' }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          {fileName ? (
            <span className="text-sm truncate">{fileName}</span>
          ) : (
            <span>Subir fotografía</span>
          )}
        </label>
      </div>

      <button
        type="submit"
        disabled={sending}
        className={`w-full font-semibold py-2 rounded-lg transition ${
          sending
            ? "bg-gray-500 text-white cursor-not-allowed"
            : "bg-[#E8B00C] text-black hover:bg-[#c49a0a]"
        }`}
      >
        {sending ? "Enviando..." : "Enviar"}
      </button>

      {status && (
        <p
          className={`text-center text-sm ${
            status.includes("Gracias") ? "text-green-400" : "text-red-400"
          }`}
        >
          {status}
        </p>
      )}
    </form>
  );
};

export default TestimonialForm;  // ✅ Asegúrate que esta línea existe